import { createSlice } from '@reduxjs/toolkit';
import extraReducers from 'src/redux/profile/extra-reducers';
import reducers from 'src/redux/profile/reducers';
import { initialProfileState } from './types';

const profileSlice = createSlice({
  name: 'profile',
  initialState: initialProfileState,
  reducers,
  extraReducers: (builder) => extraReducers(builder),
});

export const {
  setLdIdentified,
  setLdIdentifyFailed,
  updateSideNav,
  addSubMenuCount,
  removeNotification,
  deleteEachNotification,
  unClearEachNotification,
  addNewNotification,
  setActiveSidebar,
  readNotificationCount,
  readClearedNotificationCount,
  resetReadNotificationCount,
  markReadAllNotification,
  deletePassedNotification,
  clearNotificationsListData,
  changeWorkQueueTab,
  updateWorkOrderEntityStatus,
  updateServiceRequestEntityStatus,
} = profileSlice.actions;

export default profileSlice.reducer;
